<template>
    <v-flex xs12 sm12 md8 lg8 xl6 style="margin:auto">
        <v-container>
            <v-card>
                <v-card-text>
                    <v-form>
                        <h4 class="primary--text " style="text-align: center">Cấu hình thông báo</h4>
                        <fieldset style="padding: 20px;border:1px solid #daf2e6">
                            <legend class="primaryColor">Học Sinh:</legend>
                            <v-layout>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                </v-flex>
                                <v-flex xs7 sm7 md7 lg7 xl7>
                                    <v-text-field type="text" :label="$t('lang.user.email') " v-model.trim="user.email"
                                                  name="email"
                                                  maxLength="50" :disabled="true"
                                                  :data-vv-as="$t('lang.user.email')"
                                                  :error-messages="errors.first('email')"/>
                                    <v-text-field type="text" :label="$t('lang.user.phone')" v-model.trim="user.phone"
                                                  name="phone"
                                                  maxLength="50"
                                                  :disabled="true"
                                                  :data-vv-as="$t('lang.user.phone')"
                                                  :error-messages="errors.first('phone')"/>
                                    <v-text-field type="text" :label="$t('lang.user.yolearn')"
                                                  v-model.trim="user.yolearn"
                                                  name="yolearn"
                                                  key="yolearn"
                                                  maxLength="20"
                                                  :data-vv-as="$t('lang.user.yolearn')"
                                                  :error-messages="errors.first('yolearn')"/>
                                    <v-text-field type="text" :label="$t('lang.user.zalo')" v-model.trim="user.zalo"
                                                  name="zalo"
                                                  key="zalo"
                                                  maxLength="50"
                                                  :data-vv-as="$t('lang.user.zalo')"
                                                  :error-messages="errors.first('zalo')"/>
                                </v-flex>
                                <v-flex xs3 sm3 md3 lg3 xl3 style="text-align: right">
                                    <v-checkbox name="notifyEmail" key="notifyEmail" v-model="user.notifyEmail"/>
                                    <v-checkbox name="notifySMS" key="notifySMS" v-model="user.notifySms"/>
                                    <v-checkbox name="notifySMS" key="notifySMS" v-model="user.notifyYolearn"/>
                                    <v-checkbox name="notifyZalo" key="notifyZalo" v-model="user.notifyZalo"/>
                                </v-flex>
                            </v-layout>
                        </fieldset>
                        <fieldset style="padding: 20px;border:1px solid #daf2e6">
                            <legend class="primaryColor">Phụ huynh:</legend>
                            <v-layout>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                </v-flex>
                                <v-flex xs7 sm7 md7 lg7 xl7>
                                    <v-text-field type="text" :label="$t('lang.user.email') "
                                                  v-model.trim="user.parentEmail"
                                                  name="parentEmail"
                                                  key="parentEmail"
                                                  maxLength="50"
                                                  v-validate="'email'"
                                                  :data-vv-as="$t('lang.user.email')"
                                                  :error-messages="errors.first('parentEmail')"/>
                                    <v-text-field type="text" :label="$t('lang.user.phone')"
                                                  v-model.trim="user.parentPhone"
                                                  v-validate="{regex: /^[0-9()-]*$/im }"
                                                  name="parentPhone"
                                                  key="parentPhone"
                                                  maxLength="50"
                                                  :data-vv-as="$t('lang.user.phone')"
                                                  :error-messages="errors.first('parentPhone')"/>
                                    <v-text-field type="text" :label="$t('lang.user.yolearn')"
                                                  v-model.trim="user.parentYolearn"
                                                  name="parentYolearn"
                                                  key="parentYolearn"
                                                  maxLength="50"
                                                  :data-vv-as="$t('lang.user.yolearn')"
                                                  :error-messages="errors.first('parentYolearn')"/>
                                    <v-text-field type="text" :label="$t('lang.user.zalo')"
                                                  v-model.trim="user.parentZalo"
                                                  name="parentZalo"
                                                  key="parentZalo"
                                                  maxLength="50"
                                                  :data-vv-as="$t('lang.user.zalo')"
                                                  :error-messages="errors.first('parentZalo')"/>
                                </v-flex>
                                <v-flex xs3 sm3 md3 lg3 xl3 style="text-align: right">
                                    <v-checkbox name="notifyParentEmail" key="notifyParentEmail"
                                                v-model="user.notifyParentEmail"/>
                                    <v-checkbox name="notifyParentSMS" key="notifyParentSMS"
                                                v-model="user.notifyParentSMS"/>
                                    <v-checkbox name="notifyParentYoteacher" key="notifyParentYoteacher"
                                                v-model="user.notifyParentYolearn"/>
                                    <v-checkbox name="notifyParentZalo" key="notifyParentZalo"
                                                v-model="user.notifyParentZalo"/>
                                </v-flex>
                            </v-layout>
                        </fieldset>

                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="yoprimary" dark @click="updateNotify">
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="error" @click="back">
                        {{$t('lang.common.back')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-flex>
</template>

<script>
    import {router} from "../router";
    import {mapState} from "vuex";
    import {Validator} from "vee-validate";
    import {CrudService} from "@/services";
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../components/form/Upload";
    import IDatepicker from "../components/form/DatePicker";

    export default {
        name: "change-notify",
        components: {IDatepicker, IUpload},
        data() {
            return {
                submitted: false,
                user: {
                    status: 1
                },
            };
        },
        computed: mapState({
            loading: state => state.common.loading,
        }),
        methods: {
            updateNotify() {
                this.$validator.validate().then(valid => {
                        if (valid) {
                            this.user.notifyWall = true;
                            axios.post(process.env.VUE_APP_API_URL + "/changeNotify", this.user).then(
                                data => {
                                    if (!data.success) {
                                        message.error(this.$t(data.description));
                                    } else {
                                        message.success(this.$t('lang.common.update_success'));
                                    }
                                }
                            )
                        }
                    }
                );
            },
            back() {
                this.$router.go(-1);
            }
        },
        created() {
            if (this.$store.state.auth.user.userId) {
                console.log(this.$store.state.auth.user);
                CrudService.of('user').getItem(this.$store.state.auth.user.userId).then(user => {
                    this.user = user;
                });
            }
        },
        mounted() {
        }
    };
</script>
